const BrLine: React.FC<{children?: React.ReactNode}> = ({ children }) => {
  return <span style={{
    display: 'inline-block',
  }}>
    {children}
  </span>
}

export default BrLine